import { cn } from '../../../lib/utils.ts';

type Props = {
    align?: 'left' | 'center' | 'right';
    className?: string;
    topClassName?: string;
    bottomClassName?: string;
    topLevel: React.ReactNode | string;
    bottomLevel: React.ReactNode | string;
};

export const DoubleDeckerCell: React.FC<Props> = ({
    align = 'right',
    className,
    topClassName,
    bottomClassName,
    topLevel,
    bottomLevel,
}) => {
    return (
        <div
            className={cn(
                'flex flex-col py-1.5 leading-[18px]',
                align === 'left' && 'items-start text-left',
                align === 'center' && 'items-center text-center',
                align === 'right' && 'items-end text-right',
                className,
            )}
        >
            {!(!!topLevel && !!bottomLevel) && '-'}
            <div className={cn('flex items-center', topClassName)}>{topLevel}</div>
            <div className={cn('flex items-center', bottomClassName)}>{bottomLevel}</div>
        </div>
    );
};
